import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var CSMSettings = /** @class */ (function (_super) {
    __extends(CSMSettings, _super);
    function CSMSettings(fontSize, insideCutoff, outsideCutoff) {
        var _this = _super.call(this) || this;
        _this.fontSize = +fontSize;
        _this.insideCutoff = +insideCutoff;
        _this.outsideCutoff = +outsideCutoff;
        console.warn('[CSMSettings] not implemented');
        return _this;
    }
    CSMSettings.classInitializer = null;
    CSMSettings.classSymbols = null;
    CSMSettings.instanceSymbols = null; // ["fontSize", "insideCutoff", "outsideCutoff"];
    return CSMSettings;
}(ASObject));
export { CSMSettings };
